import {createEntityAdapter} from '@reduxjs/toolkit';

import type {ClientThread} from '../types/extended';

export const threadsAdapter = createEntityAdapter<ClientThread>({
    selectId: (thread) => thread.id,
    sortComparer: (thread, nextThread) => (thread.last_reply_at < nextThread.last_reply_at ? 1 : -1),
});
